







































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { dataList, boxList } from "@/components/listData";
import tabs from "./components/tabs.vue";
import { getEngine } from "@/req/homes";
import download from "./components/download.vue";
import reagister from "../../components/reagister.vue";
import authCodeSearch from "./components/authCodeSearch.vue";
import { dataModel } from "./engine";
import securityVerification from "../../components/securityVerification.vue";
@Component({
  components: {
    tabs,
    download,
    reagister,
    authCodeSearch,
    securityVerification,
  },
})
export default class Home extends Vue {
  public activeIndex: any = 1;
  public selectModel = {};
  public dataModel = dataModel;
  public dataList = dataList;
  public created() {
    this.getEngineList();
    if (this.$route.query.tab) {
      const selectIndex: any = this.$route.query.tab;
      this.activeIndex = Number(selectIndex);
      this.selectModel = this.dataModel[selectIndex - 1];
    } else {
      this.selectModel = this.dataModel[this.activeIndex - 1];
    }
  }
  public async getEngineList() {
    const res = await getEngine();
    if (res.code == 200) {
      const obj = Object.assign({}, res.data);
      res.data.forEach((its) => {
        if (its.engine_list && its.engine_list.length) {
          its.engine_list.forEach((itd) => {
            itd.list.forEach((element) => {
              element.timer = this.$fn.toViewDates(element.update_time * 1000);
            });
          });
        }
        this.dataModel.forEach((item, index) => {
          if (its.engine_type == item.id) {
            item.downloadInfo = its.engine_list;
          }
        });
      });
    }
  }
  public linkToDevelopers() {
    window.open(
      "http://pure-engine.996yinqing.com/#/login",
      "_blank"
    );
  }
  public applicationCourse() {
    window.open(
      "https://docs.qq.com/doc/DWmVpUklPVENWRXdU",
      "_blank"
    );
  }
  public download(id) {
    const $securityVerification = (this as any).$refs.securityVerification;
    $securityVerification.show(id);
  }
  public registerBtn() {
    const $register = (this as any).$refs.register;
    $register.show();
  }
  public addBoxDownload(item) {
    if (item.state == 1) {
      window.open(
        "https://static.dhsf.xqhuyu.com/offical" + item.link,
        item.target
      );
    }
    if (item.state == 2) {
      window.open(item.link, item.target);
    }
    if (item.state == 3) {
      window.open(item.link, item.target);
    }
    if (item.state == 4) {
      window.open(item.link, item.target);
    }
  }
  public selectCateRow(row) {
    this.activeIndex = row.id;
    this.selectModel = row;
  }
  public authCodeSearch() {
    window.open("/certificateInquiry", "_blank");
    // const $authCodeSearch = (this as any).$refs.authCodeSearch;
    // $authCodeSearch.show();
  }
}
